import { render, staticRenderFns } from "./groceryBagInfo.vue?vue&type=template&id=763ab640&"
import script from "./groceryBagInfo.vue?vue&type=script&lang=js&"
export * from "./groceryBagInfo.vue?vue&type=script&lang=js&"
import style0 from "./groceryBagInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports